







import { Component, Vue } from "vue-property-decorator";
import AdminScheduleLayout from "./AdminScheduleLayout.vue";
import UserScheduleLayout from "./UserScheduleLayout.vue";
import { isAdmin, isSuperAdmin } from "@/common/role_utils";

@Component({
  components: {
    AdminScheduleLayout,
    UserScheduleLayout,
  },
})
export default class ScheduleLayout extends Vue {
  get admin() {
    return isAdmin() || isSuperAdmin();
  }
}
